import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import { useRouterCreationDrawer } from './RouterCreationDrawer';
import RouterList from './RouterList';

const RouterListPage = () => {
    const { t } = useTranslation('routerList');
    const { permissions: accountPermissions } = useAccount();

    const creationDrawer = useRouterCreationDrawer();

    const extra = hasPermissions(accountPermissions, [permissionKind.createRouter]) ? (
        <Button icon={<PlusOutlined />} onClick={creationDrawer.open} type="primary">
            {t('routerList:actions.newRouter')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('routerList:title')}>
            {creationDrawer.render()}
            <RouterList onCreate={creationDrawer.open} />
        </ConsolePageWithHeader>
    );
};

export default RouterListPage;
